package com.elan.edubridge.shared.domain.policy

import com.elan.edubridge.shared.domain.model.AppSection
import com.elan.edubridge.shared.domain.model.Permission
import com.elan.edubridge.shared.domain.model.UserRole

object RolePolicy {
    fun sectionsFor(role: UserRole): List<AppSection> = when (role) {
        UserRole.STUDENT -> listOf(
            AppSection.HOME,
            AppSection.ATTENDANCE,
            AppSection.ASSIGNMENTS,
            AppSection.NOTICES,
        )
        UserRole.TEACHER -> listOf(
            AppSection.HOME,
            AppSection.CLASSES,
            AppSection.STUDENTS,
            AppSection.ATTENDANCE,
            AppSection.ASSIGNMENTS,
            AppSection.NOTICES,
        )
        UserRole.ACADEMY_OWNER -> listOf(
            AppSection.HOME,
            AppSection.ACADEMIES,
            AppSection.CLASSES,
            AppSection.STUDENTS,
            AppSection.ATTENDANCE,
            AppSection.ASSIGNMENTS,
            AppSection.NOTICES,
            AppSection.USERS,
        )
        UserRole.SUPER_ADMIN -> AppSection.entries
    }

    /**
     * 인가 판정은 역할 열거가 아니라 권한 비교로 한다(§2.2).
     * 역할이 하나 늘 때마다 모든 판정 지점을 고쳐야 하던 문제를 없앤다.
     * rules의 `isStaff()` / `isAcademyAdmin()`과 같은 기준이다(§2.3).
     */
    fun isStaff(permission: Permission): Boolean = permission.atLeast(Permission.EDITOR)

    fun canManageAcademy(permission: Permission): Boolean = permission.atLeast(Permission.ADMIN)

    fun canManageUsers(permission: Permission): Boolean = permission.atLeast(Permission.ADMIN)

    /** 플랫폼 범위는 학원 권한이 아니라 전역 역할로 판정한다(§2.1). */
    fun canManagePlatform(role: UserRole): Boolean = role == UserRole.SUPER_ADMIN
}
